import { Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function LetsConnect() {
  return <section data-section-id="233796" id="start-your-project" className="w-full dark bg-background py-24 md:py-32 lg:py-40 flex items-center justify-center border-b border-border/50">
      <div className="container mx-auto px-4 text-center max-w-3xl flex flex-col items-center">
        <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-none mb-8 border border-primary/20">
          <Mail className="size-8 text-primary" strokeWidth={1.5} />
        </div>
        
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground mb-6 tracking-tighter uppercase">
          GET CONNECTED.
        </h1>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed max-w-2xl mx-auto font-default">
          Powering your site from day one. Our team provides 24/7 technical support and rapid mobilization for temporary power, distribution boards, and industrial infrastructure.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4 w-full sm:w-auto">
          <Button size="lg" className="rounded-none px-8 h-12 text-base font-bold bg-primary text-primary-foreground hover:bg-primary/90 transition-all" asChild>
            
          </Button>
          <Button size="lg" variant="outline" className="rounded-none px-8 h-12 text-base bg-transparent border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all" asChild>
            <Link to="/services">
              VIEW CAPABILITIES
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}